import * as React from 'react';
import { Row, Col } from 'react-bootstrap';

import type LocationDepartmentVM from 'ab-viewModels/location/locationDepartment.viewModel';

import { SegmentLabel } from '@acceligentllc/storybook';

import DepartmentList from './LocationList';
import Vendor from './Vendor';

type Props = {
	locations: LocationDepartmentVM[];
	vendors: { label: string; value: number; }[];
	onVendorChange: (name: Nullable<string>) => void;
};

const Inventory = (props: Props) => {
	const { locations, vendors, onVendorChange } = props;

	return (
		<>
			<div className="user-upsert__section-label p-t-m m-b-m">
				<SegmentLabel
					label="Inventory"
					tooltip="Stock levels and restock configuration for this item across all locations and departments, including current stock, minimum, and maximum quantity thresholds."
				/>
			</div>
			<Row>
				<Col md={12}><DepartmentList locations={locations} /></Col>
				<Col md={12}><Vendor onVendorChange={onVendorChange} vendors={vendors} /></Col>
			</Row>
		</>
	);
};

export default React.memo(Inventory);
